import React, { useEffect, useState } from 'react';
import { Button, EButtonType, EInputType, Input, KitIcons } from '@repo/apg-ui';
import { Accordion } from 'react-bootstrap';
import './Filters.scss';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getFilters } from '../../store/products/actions';
import { AppState } from '../../store';
import { SelectedFilters } from '../../store/products/types';

interface Props {
  handleTagChange: (select: string, value: string, radiotype?: boolean) => void;
  selectedFilters: SelectedFilters;
  clearFilters: () => void;
  setShowFilters: (show: boolean) => void;
}

export const Filters = React.memo(({ handleTagChange, selectedFilters, clearFilters, setShowFilters }: Props) => {
  const dispatch = useDispatch();
  const filters = useSelector((state: AppState) => state.products.filters);
  const [activeKey, setActiveKey] = useState('0');

  const toggleAccordion = (eventKey) => {
    setActiveKey(activeKey === eventKey ? '' : eventKey);
  };

  useEffect(() => {
    if (!filters) {
      dispatch(getFilters());
    }
  }, [dispatch]);

  const isChecked = (group, filter) => {
    if (selectedFilters?.tags && Object.keys(selectedFilters?.tags).includes(group.title)) {
      return selectedFilters?.tags[group.title].includes(filter.code);
    }
    return false;
  };

  return (
    <div className='filters'>
      <div className='d-flex justify-content-between align-items-center'>
        <h4 className='filters-title'>
          <div onClick={() => setShowFilters(false)}>
            <KitIcons.EyeIcon />
          </div>
          Filters
        </h4>
        <div className='filters-button'>
          <Button buttonType={EButtonType.BasicLink} onClick={() => clearFilters()}>
            <FormattedMessage id='ec.checkout.clearAll' defaultMessage='Filter löschen' />
          </Button>
        </div>
      </div>
      <div className={'d-flex flex-column w-auto flex-nowrap'}>
        <Accordion defaultActiveKey='0' activeKey={activeKey} className={'pb-5'}>
          {filters.length > 0 &&
            filters.map((group, groupIdx) => (
              <Accordion.Item eventKey={`filter-${groupIdx}`} key={groupIdx}>
                <Accordion.Header
                  onClick={() => toggleAccordion(`filter-${groupIdx}`)}
                  className={`${activeKey === `filter-${groupIdx}` ? '' : 'item-closed-filter'}`}
                >
                  <h4 className={`filter-title ${activeKey === `filter-${groupIdx}` ? '' : 'closed-filter'}`}>
                    {group.title}
                  </h4>
                </Accordion.Header>
                <Accordion.Body>
                  {group.values.map((filter, idx) => {
                    return (
                      <div className='form-check font-14'>
                        <Input
                          inputType={EInputType.Checkbox}
                          type={'checkbox'}
                          name={`group_${groupIdx}_product_${idx}`}
                          value={filter.code}
                          checkboxLabel={filter.label}
                          onChange={() =>
                            handleTagChange(
                              group.title,
                              filter.code,
                              group.type && group.type === 2, // 2 = Radiolist
                            )
                          }
                          checked={isChecked(group, filter)}
                          inputWrapperClass={'font-10'}
                        />
                      </div>
                    );
                  })}
                </Accordion.Body>
              </Accordion.Item>
            ))}
        </Accordion>
      </div>
    </div>
  );
});
